import React from "react"
import {connect} from "react-redux"
import {Time} from "shared-components"
import AuthActions from "redux-store/models/auth"

const TopHeader = ({accountInfo, logOut, role, CenterCls}) => {
    return (
        <div
            className={`TopHeader ${CenterCls === "Center--Big WideForm" && "small-menu"}`}
        >
            <Time/>
            <span
                className="logOutBtn"
                onClick={() => {
                    logOut()
                    window.location.hash = "login"
                }}
            >
                Log OUT
          </span>
        </div>
    )
}

const mapStatToProps = (state) => ({
    accountInfo: state.auth.accountInfo,
    CenterCls: state.auth.CenterCls,
})
export default connect(mapStatToProps, AuthActions)(TopHeader)
